import { matchPath } from 'react-router-dom';

import { RADAR_PRIVACY_PATH, RADAR_TERMS_PATH } from '~/views/RadarView/paths';

// MAIN VIEWS
export const HOME_PATH = '/';
export const PACKS_PATH = HOME_PATH;
export const DIAMONDS_PATH = '/loots';
export const CARDS_PATH = '/cards';
export const CARD_PATH = '/cards/:cardId';
export const DIAMOND_DUNGEON = '/diamond-dungeon';
export const SEASON_TICKET_PATH = '/season-ticket';
export const RADAR_PATH = '/radar/';
export const COMICS_PATH = '/comics';
export const NEWS_PATH = '/newsFeed';
export const JOBS_PATH = '/jobs';
export const HERO_PATH = '/hero';
export const OPEN_CARDS_PATH = '/openCards';
export const OPEN_PURCHASE_PATH = '/purchases/:purchaseId';

// LOGIN VIEWS
export const LOGIN_PATH = '/login';
export const LOGIN_REQUIRED_PATH = '/login-required';
export const REGISTER_PATHNAME = '/signup';
export const EMAIL_REGISTER_PATH = '/email-register';
export const REGISTER_TERMS_PATH = '/register-terms';
export const REQUEST_EMAIL_VERIFICATION_PATH = '/request-verification-code';
export const EMAIL_VERIFICATION_PATH = '/verifyEmail';
export const USER_DETAILS_PATH = '/user-details';
export const REQUEST_PASSWORD_RESET_PATH = '/request-password-reset';
export const PASSWORD_RESET_CODE_PATH = '/password-reset-code';
export const PASSWORD_RESET_PATH = '/resetPassword';
export const FACEBOOK_LOGIN = '/facebookLogin';
export const GOOGLE_LOGIN = '/googleLogin';
export const TWITTER_LOGIN = '/twitterLogin';
export const TWITCH_LOGIN = '/twitchLogin';
export const STEAM_LOGIN = '/steamLogin';
export const HUAWEI_LOGIN = '/login/huawei';
export const APPLE_LOGIN = '/apple-login';
export const loginRedirectPathnames = [
  FACEBOOK_LOGIN,
  GOOGLE_LOGIN,
  TWITTER_LOGIN,
  TWITCH_LOGIN,
  STEAM_LOGIN,
  HUAWEI_LOGIN,
  APPLE_LOGIN,
] as const;

export const emailVeryficationPaths = [
  REQUEST_EMAIL_VERIFICATION_PATH,
  EMAIL_VERIFICATION_PATH,
];
export const CHANGE_PASSWORD_PATH = '/change-password';

// POPUP VIEWS
export const DAILY_PATH = '/daily';
export const SEASON_TICKET_SUCCESS_PATH = '/season-ticket/success';
export const SEASON_TICKET_MODAL_PATH = '/season-ticket-subscription';
export const seasonTicketModalPaths = [
  SEASON_TICKET_SUCCESS_PATH,
  SEASON_TICKET_MODAL_PATH,
  '/discord-connect',
] as const;
export const MENU_PATH = '/menu';
export const TUTORIAL_PATH = '/tutorial';
export const TUTORIAL_PATH_CREATOR = (id = ':id'): string =>
  `${TUTORIAL_PATH}/${id}`;
export const COLLECTION_PATH = '/collect/:alias';
export const EXPLORATION_QUEST_PATH = '/offers';
export const EARN_COINS_PATH = '/earnLootcoins';
export const EARN_DIAMONDS_PATH = '/earnDiamonds';
export const LEGACY_SURVEY_PATH = '/survey';
export const SURVEY_PATH = '/vote';
export const LEGACY_SURVEY_PATH_BY_ID = '/survey/:idOrAlias';
export const SURVEY_PATH_BY_ID = '/vote/:idOrAlias';
export const SURVEY_PATHS = [
  LEGACY_SURVEY_PATH_BY_ID,
  SURVEY_PATH_BY_ID,
  LEGACY_SURVEY_PATH,
  SURVEY_PATH,
] as const;
export const REDEEM_CODE_PATH = '/redeemCode';
export const ALL_TUTORIALS_PATH = '/tutorials';
export const CONTACT_PATH = '/support';
export const NEWSLETTER_PATH = '/newsletter';
export const VERSION_PATH = '/version';
export const PRIVACY_POLICY_PATH = '/web-privacy';
export const PRIVACY_POLICY_APP_PATH = '/privacy';
export const LEGAL_PATH = '/legal';
export const TERMS_PATH = '/terms';
export const WITHDRAWAL_PATH = '/withdrawal';

export const DEALS_PATH = '/deals/:dealId';

export const MODAL_PATHS = [
  '/changePassword',
  '/recruit',
  '/loots/:lootId',
  '/loots/:lootId/purchase',
  DAILY_PATH,
  MENU_PATH,
  RADAR_TERMS_PATH,
  RADAR_PRIVACY_PATH,
  CARD_PATH,
  COLLECTION_PATH,
  EXPLORATION_QUEST_PATH,
  ...seasonTicketModalPaths,
  ...SURVEY_PATHS,
  TUTORIAL_PATH_CREATOR(),
  EARN_COINS_PATH,
  EARN_DIAMONDS_PATH,
  DEALS_PATH,
];

export function isPopupPath(path: string): boolean {
  return !!matchPath(path, { path: MODAL_PATHS });
}

export const diamondsDeepLinkEarnPath = '/quests_earn';
export const diamondsDeepLinkSpendPath = '/quests_spend';
